/*
* @Author: tengmaoqing
* @Date:   2018-04-26 17:57:42
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-27 11:50:34
*/
import Vue from 'vue';
import ProgressBar from '@/components/progress-bar';
import { asyncData } from '@/helper/vueAsyncData';
import { isWin, isWechat } from '@/helper/uaCheck';
import { getUserInfo, getToken } from '@/helper/loginStatusManger.js';
import VueLazyload from 'vue-lazyload';
// import * as Sentry from '@sentry/browser';
import parse from 'url-parse';
import 'modernizr';
import { App } from './init-vue-app';

Vue.use(VueLazyload);

// if (process.env.NODE_ENV === 'production' && process.env.PROJECT_NAME !== 'hsbpc') {
//   require('statistics');
//   Sentry.init({
//     dsn: 'https://dc3c8337d35c41a7a7bd1c8054223210@sentry.io/1297406',
//     integrations: [new Sentry.Integrations.Vue({ Vue })]
//   });
// }

// polyfill
if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
}

class ClientApp extends App {
  init (params, options = {}) {
    super.init(params);
    this.addUAClass();
    this.mixinVue();

    this.isServerRendered = document.querySelector('#app');
    this.options = options;

    this.initBar();
    this.initStoreState(this.store);
    this.initLoginTypePlatform();
    this.addReadyHooks(this.router);
  }

  initLoginTypePlatform () {
    const pid = this.store.state.pid;
    const wechatLoginPid = this.store.state.config.wechatLoginPid;
    if ((wechatLoginPid.indexOf(pid) !== -1) && isWechat()) {
      this.store.state.config.platform = 1;
      this.store.state.config.loginType = 'wechat';
    }
  }

  initStoreState (store) {
    if (window.__INITIAL_STATE__) {
      store.replaceState(window.__INITIAL_STATE__);
    }
    const pid = parse(window.location.href, true).query.pid;
    // 回收宝活动id
    const hsbAid = parse(window.location.href, true).query.hsbAid;
    const platform = parse(window.location.href, true).query.platform;

    store.commit('user/setToken', getToken());
    store.commit('user/setUserInfo', getUserInfo());
    if (hsbAid) {
      store.commit('setPid', hsbAid);
    } else {
      store.commit('setPid', pid);
    }
    store.commit('loadConfig');
    // TO DO
    if (platform && +platform !== 2) {
      store.state.config.platform = platform;
    }
  }

  initBar () {
    this.bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount();
    document.body.appendChild(this.bar.$el);
  }

  addRouterHooks () {
    const router = this.router;

    router.beforeEach((to, from, next) => {
      this.bar.start();
      next();
    });

    router.afterEach((to, from) => {
      this.bar.finish();
    });

    router.beforeResolve((to, from, next) => {
      const matched = router.getMatchedComponents(to);
      const prevMatched = router.getMatchedComponents(from);
      let diffed = false;
      const activated = matched.filter((c, i) => {
        return diffed || (diffed = (prevMatched[i] !== c));
      });
      if (!activated.length) {
        return next();
      }

      Promise.all(activated.map(c => {
        return asyncData(c, to, this.store);
      })).then(() => {
        // 停止加载指示器(loading indicator)
        next();
        this.dispatchPageLoaded();
      }).catch(next);
    });
  }

  dispatchPageLoaded () {
    this.options.pageLoaded && this.options.pageLoaded(this.vueApp, this.store, this.router);
  }

  addReadyHooks (router) {
    router.onReady(() => {
      const currentRoute = router.currentRoute;
      const matched = router.getMatchedComponents(currentRoute);
      const app = this.vueApp;

      this.addRouterHooks();
      this.updatePageAnimate();
      if (!this.isServerRendered) {
        Promise.all(matched.map(Component => asyncData(Component, currentRoute, this.store))).then(() => {
          app.$mount(document.body.appendChild(document.createElement('div')));
          this.dispatchPageLoaded();
          this.closePageAnimate();
        });
      } else {
        matched.map(Component => Component.registerModule && Component.registerModule(this.store, true));
        app.$mount('#app');
        this.dispatchPageLoaded();
        this.closePageAnimate();
      }
    });
  }

  updatePageAnimate () {
    // const loadingEl = document.getElementById('pageLoading');
    // loadingEl && (loadingEl.querySelector('.page-loading-text').innerHTML += ' .');
  }

  closePageAnimate () {
    const loadingEl = document.getElementById('pageLoading');
    if (loadingEl) {
      loadingEl.parentNode.removeChild(loadingEl);
    }
  }

  addUAClass () {
    let className = '';
    if (isWin()) {
      className += ' is-win';
    }

    if (isWechat()) {
      className += ' is-wechat';
    }

    document.documentElement.className += className;
  }

  mixinVue () {
    Vue.mixin({
      beforeRouteUpdate (to, from, next) {
        asyncData(this.$options, to, this.$store, false, true).then(next).catch(next);
      }
    });
  }
};

export { ClientApp };

export default (...args) => new ClientApp(...args);



// WEBPACK FOOTER //
// ./src/system/init/init-client-app.js